import { render, staticRenderFns } from "./ClientCosts.vue?vue&type=template&id=6a81b8de&scoped=true"
import script from "./ClientCosts.vue?vue&type=script&lang=js"
export * from "./ClientCosts.vue?vue&type=script&lang=js"
import style0 from "./ClientCosts.vue?vue&type=style&index=0&id=6a81b8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81b8de",
  null
  
)

export default component.exports